import { LoadingOverlay } from 'components/core/loading-overlay';

// Same full-screen Buddy loader the app shows next, so startup doesn't flash a second loading screen.
export function AuthPanelLoader() {
  return <LoadingOverlay />;
}
